import { OrgCreateSchema } from '@account-manager/shared';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { api } from '../api.js';

interface FormData {
  name: string;
  slug: string;
  countryCode: string;
  baseCurrency: string;
}

export function CreateOrg() {
  // biome-ignore lint/suspicious/noExplicitAny: zod input/output type mismatch with @hookform/resolvers — defaults make countryCode/baseCurrency optional in input but required in output
  const resolver = zodResolver(OrgCreateSchema) as any;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormData>({
    resolver,
    defaultValues: { countryCode: 'EC', baseCurrency: 'USD' },
  });
  const [error, setError] = useState<string | null>(null);

  const onSubmit = handleSubmit(async (data) => {
    try {
      const res = await api<{ id: string; role: string }>('/orgs', {
        method: 'POST',
        body: JSON.stringify(data),
      });
      await api('/orgs/switch', {
        method: 'POST',
        body: JSON.stringify({ orgId: res.id }),
      });
      // Admin-mandatory MFA: redirect to setup if not enrolled
      window.location.href = '/mfa/setup';
    } catch (e: unknown) {
      setError((e as Error).message);
    }
  });

  return (
    <div className="mx-auto max-w-md">
      <h1 className="mb-4 text-xl font-semibold">Crear organización</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <label className="block">
          <span className="text-sm">Nombre</span>
          <input {...register('name')} className="mt-1 w-full rounded border px-3 py-2" />
          {errors.name && <span className="text-xs text-red-600">{errors.name.message}</span>}
        </label>
        <label className="block">
          <span className="text-sm">Slug</span>
          <input
            {...register('slug')}
            placeholder="acme-co"
            className="mt-1 w-full rounded border px-3 py-2"
          />
          {errors.slug && <span className="text-xs text-red-600">{errors.slug.message}</span>}
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="text-sm">País</span>
            <input
              {...register('countryCode')}
              maxLength={2}
              className="mt-1 w-full rounded border px-3 py-2 uppercase"
            />
          </label>
          <label className="block">
            <span className="text-sm">Moneda</span>
            <input
              {...register('baseCurrency')}
              maxLength={3}
              className="mt-1 w-full rounded border px-3 py-2 uppercase"
            />
          </label>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full rounded bg-blue-600 py-2 text-white disabled:opacity-50"
        >
          Crear
        </button>
      </form>
    </div>
  );
}
